export default function session(
	state = {session: null, comments: [], participants: [] },
	action
) {
	var copy = Object.assign({}, state);
	if (action.type === "DISPATCH_SESSION") {
		copy.session = action.session;
		return copy
    }
		else if(action.type === "COMMENTS_LOADED") {
				copy.comments = action.comments;
				return copy
		    }
		else if(action.type === "NEW_COMMENT") {
				copy.comments = action.comments;
				return copy
		    }
				else if(action.type === "DISPATCH_PARTICIPANTS") {
						copy.participants = action.participants;
						return copy
						}
    else {
  		return state;
  	}
  }
